<template>
  <div class="app">
    <!-- Uncomment this to add banner -->
    <!-- <div v-if="$route && $route.name === 'register'" class="banner-notification-container">
      <p class="banner-notification-text">
        {{ $t('bannerText') }}
      </p>
    </div> -->
    <application-header class="header" />
    <div class="main">
      <router-view />
    </div>
    <application-footer v-if="!isRenaultEvent()" class="footer" />
  </div>
</template>

<script>
import ApplicationHeader from './application-header.vue'
import ApplicationFooter from './application-footer.vue'

export default {
  name: 'main-navigator',
  components: {
    ApplicationHeader,
    ApplicationFooter,
  },
  methods: {
    isRenaultEvent() {
      return window.location.href.includes('convention-in-dubrovnik-5f3d')
    },
  },
}
</script>

<style scoped>
.app {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.header {
  position: -webkit-sticky;
  position: sticky;
  z-index: 100;
  top: 0;
}

.main {
  flex-grow: 1;
}

@media only screen and (max-width: 800px) {
  .main {
    margin: 0 1.5rem;
  }
}

.footer {
  margin-top: 3rem;
  flex-shrink: 0;
}

.banner-notification-container {
  width: 100%;
  background-color: #007bff;
  padding: 8px 24px;
}

.banner-notification-text {
  color: white;
  font-size: 16px;
  font-family: Source Sans Pro;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
  max-width: 1168px;
  margin: 0 auto;
}
</style>
